// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"MappingVariablesPopUp_saveButton__Q1Z7W"};